import React from "react";
import ContentLoader from "react-content-loader";
import { fakeSettings } from "@/constants/constants";

const UsageDetailsFake = ({ withContainer = true }) => {
  return (
    <div className={withContainer ? "container" : ""}>
      <section className="usages-container">
        <div className="usages-container--column-1">
          <div className="usages-container--usage-box" style={{ margin: "0" }}>
            <ContentLoader
              height="200"
              width="100%"
              viewBox="50 50 100% 100vh"
              {...fakeSettings}
            >
              <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
            </ContentLoader>
          </div>
          <ContentLoader
            height="53"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
          </ContentLoader>

          <div className="row" style={{ margin: "1rem 0px", gap: "1rem" }}>
            <div className="col-sm-6 col-xs-12">
              <ContentLoader
                height="160"
                width="100%"
                viewBox="50 50 100% 100vh"
                {...fakeSettings}
              >
                <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
              </ContentLoader>
            </div>
            <div className="col-sm-6 col-xs-12">
              <ContentLoader
                height="160"
                width="100%"
                viewBox="50 50 100% 100vh"
                {...fakeSettings}
              >
                <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
              </ContentLoader>
            </div>
            <div className="col-sm-6 col-xs-12">
              <ContentLoader
                height="160"
                width="100%"
                viewBox="50 50 100% 100vh"
                {...fakeSettings}
              >
                <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
              </ContentLoader>
            </div>
            <div className="col-sm-6 col-xs-12">
              <ContentLoader
                height="160"
                width="100%"
                viewBox="50 50 100% 100vh"
                {...fakeSettings}
              >
                <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
              </ContentLoader>
            </div>
            <div className="col-sm-6 col-xs-12">
              <ContentLoader
                height="160"
                width="100%"
                viewBox="50 50 100% 100vh"
                {...fakeSettings}
              >
                <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
              </ContentLoader>
            </div>
            <div className="col-sm-6 col-xs-12">
              <ContentLoader
                height="160"
                width="100%"
                viewBox="50 50 100% 100vh"
                {...fakeSettings}
              >
                <rect x="0" y="0" rx="4" ry="4" width="100vw" height="286" />
              </ContentLoader>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .usages-container {
          display: flex;
          flex-direction: column;
          &--usage-box {
            margin: 0;
          }
        }

        @media (min-width: 768px) {
          .usages-container {
            flex-direction: row;
            justify-content: space-between;
            &--column-1 {
              width: 70%;
            }
          }
        }
      `}</style>
    </div>
  );
};

export default UsageDetailsFake;
